<template>
    <div>
        <Modal v-model="modalShow" title="退出未成年人模式" class-name="vertical-center-modal my-modal"
            @on-cancel="close" :mask-closable="false" width="385" :footer-hide="true">
            <div class="tc">
                请输入监护密码
            </div>
            <div class="tc" style="margin:15px 0;">
                <inputPwd ref="inputPwdRef"/>
            </div>
            <div class="tc" style="margin-top:20px;">
                <ButtonGroup shape="circle">
                    <Button type="warning" @click="exitAction" style="width:230px;">退出未成年人模式</Button>
                </ButtonGroup>
            </div>
        </Modal>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import inputPwd from './inputPwd.vue'; //密码输入
export default {
    name: "setD",
    components: { inputPwd },
    data() {
        return {
            modalShow: false,
        };
    },
    computed: {
        ...mapState(['user', 'isLogin', 'wcnCfg']),
    },
    mounted() {
    },
    methods: {
        async exitAction(){
            if(!this.wcnCfg){
                return this.$Message.warning('请先设置监护密码！');
            }
            let pwd = this.$refs.inputPwdRef.getCodeValue()
            if(!pwd){
                return this.$Message.error('请输入监护密码！');
            }
            this.$refs.inputPwdRef.init()
            if(this.wcnCfg.pwd != pwd){
                return this.$Message.error('监护密码错误！');
            }
            await this.$store.commit('updateWcnCfg', null)
            this.modalShow = false;
            this.$Message.success('您已退出未成年人模式！');
        },
        //显示弹窗
        show() {
            this.modalShow = true;
            this.$nextTick(() => {
                this.$refs.inputPwdRef.init()
            })
        },
        //关闭弹窗
        close() {
            this.$refs.inputPwdRef.init()
            this.modalShow = false;
        }
    }
};
</script>

<style lang="scss">
.my-modal .ivu-modal-header {
    border-bottom: 0px solid #e8eaec;
    padding: 14px 16px 0 16px;
}
</style>
<style lang="scss" scoped>
.tc{
    text-align: center;
}
.cu{
    cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/wcn/setD.vue